function coveraxPrefersApplePay() {
  const ua = navigator.userAgent || '';
  if (/Android/i.test(ua)) return false;
  if (window.ApplePaySession) return true;
  return /iPhone|iPad|iPod/i.test(ua);
}

function coveraxSyncPayWallets(root = document) {
  const wallet = coveraxPrefersApplePay() ? 'apple' : 'google';
  root.querySelectorAll('[data-pdp-pay]').forEach((el) => {
    el.setAttribute('data-wallet', wallet);
  });
}

function coveraxDecodePdpEntities(root) {
  if (typeof window.coveraxDecodeVisibleEntities === 'function') {
    window.coveraxDecodeVisibleEntities(root || document.body);
  }
}

coveraxSyncPayWallets();
coveraxDecodePdpEntities();
document.addEventListener('shopify:section:load', () => coveraxDecodePdpEntities());

if (!customElements.get('coverax-pdp')) {
  customElements.define(
    'coverax-pdp',
    class CoveraxPdp extends HTMLElement {
      connectedCallback() {
        coveraxSyncPayWallets(this);
        coveraxDecodePdpEntities(this);
        this.cards = Array.from(this.querySelectorAll('[data-variant-card]'));
        this.variantInput = this.querySelector('.product-variant-id');
        this.stockEl = this.querySelector('[data-pdp-stock]');
        this.submitButton = this.querySelector('[name="add"]');
        this.submitLabel = this.submitButton?.querySelector('[data-pdp-submit-label]');
        this.summaryPrice = this.querySelector('[data-pdp-summary-price]');
        this.summaryComparePrice = this.querySelector('[data-pdp-summary-compare-price]');
        this.summaryCompareWrap = this.querySelector('[data-pdp-compare-wrap]');
        this.offerPrice = this.querySelector('[data-pdp-offer-price]');
        this.savePercentEl = this.querySelector('[data-pdp-save-percent]');
        this.shippingEl = this.querySelector('[data-pdp-shipping]');
        this.shippingFromEl = this.querySelector('[data-pdp-shipping-from]');
        this.lastOfferCents = 0;
        this.plusPointsEl = this.querySelector('[data-pdp-plus-points]');
        this.plusPointsRate = parseInt(this.dataset.plusPointsPerEuro || '5', 10) || 5;
        this.unitPrice = this.querySelector('[data-pdp-unit-price]');
        this.quantityInput = this.querySelector('.quantity__input');
        this.quantitySelector = this.querySelector('[data-pdp-quantity-selector]');
        this.quantityOptions = Array.from(this.querySelectorAll('[data-pdp-quantity-option]'));
        this.quantityCurrent = this.querySelector('[data-pdp-quantity-current]');
        this.quantityProgress = this.querySelector('[data-pdp-quantity-progress]');
        this.quantitySavings = Array.from(this.querySelectorAll('[data-pdp-quantity-saving]'));
        this.mengeOptions = Array.from(this.querySelectorAll('[data-pdp-menge-option]'));
        this.mengeCurrentEl = this.querySelector('[data-pdp-menge-current]');
        this.mengeProgress = this.querySelector('[data-pdp-menge-progress]');
        this.mengeSavings = Array.from(this.querySelectorAll('[data-pdp-menge-saving]'));
        this.pricePerPieceEl = this.querySelector('[data-pdp-price-per-piece]');
        this.gallery = this.querySelector('.coverax-pdp__gallery');
        this.viewport = this.querySelector('.coverax-pdp__viewport');
        this.track = this.querySelector('[data-pdp-track]');
        this.pager = this.querySelector('.coverax-pdp__pager');
        this.thumbsWrap = this.querySelector('[data-pdp-thumbs]');
        this.thumbs = Array.from(this.querySelectorAll('[data-pdp-thumb]'));
        this.allSlides = Array.from(this.querySelectorAll('[data-pdp-slide]'));
        this.prevBtn = this.querySelector('[data-pdp-prev]');
        this.nextBtn = this.querySelector('[data-pdp-next]');
        this.counterEl = this.querySelector('[data-pdp-counter]');
        this.progressThumb = this.querySelector('[data-pdp-progress-thumb]');
        this.counterTemplate = this.counterEl?.textContent || '{{ current }}/{{ total }}';
        const selectedCard = this.querySelector('[data-variant-card].is-selected');
        this.activeIndex = 0;
        this.filterSlides(selectedCard?.dataset.variantId || '', selectedCard?.dataset.mediaId || '');

        this.quantityOptions.forEach((option) => {
          option.addEventListener('change', () => this.selectQuantityOption(option));
        });
        this.updateQuantityOptions();

        this.mengeOptions.forEach((option) => {
          option.addEventListener('change', () => this.selectMengeOption(option));
        });
        this.updateMengeOptions(this.selectedCard());

        this.initGebindePanel();

        this.cards.forEach((card) => {
          card.addEventListener('click', () => this.selectCard(card));
          card.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.selectCard(card);
            }
          });
        });

        this.querySelectorAll('.coverax-pdp__accordion summary').forEach((summary) => {
          summary.addEventListener('pointerup', (event) => {
            if (event.pointerType === 'mouse' || event.pointerType === 'touch' || event.pointerType === 'pen') {
              summary.blur();
            }
          });
        });

        this.prevBtn?.addEventListener('click', (event) => {
          event.preventDefault();
          event.currentTarget.blur();
          this.goToSlide(this.activeIndex - 1);
        });
        this.nextBtn?.addEventListener('click', (event) => {
          event.preventDefault();
          event.currentTarget.blur();
          this.goToSlide(this.activeIndex + 1);
        });

        this.thumbs.forEach((thumb) => {
          const showThumb = () => {
            const mediaId = thumb.dataset.mediaId || '';
            const index = this.slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
            if (index >= 0) this.goToSlide(index, false);
          };
          thumb.addEventListener('mouseenter', showThumb);
          thumb.addEventListener('click', showThumb);
        });

        this.lastViewportWidth = this.viewport?.clientWidth || 0;
        this.boundResize = () => {
          const width = this.viewport?.clientWidth || 0;
          if (width === this.lastViewportWidth) return;
          this.lastViewportWidth = width;
          this.goToSlide(this.activeIndex, false);
        };
        this.resizeObserver = new ResizeObserver(this.boundResize);
        if (this.viewport) this.resizeObserver.observe(this.viewport);

        this.viewport?.addEventListener('scroll', () => {
          this.viewport.scrollLeft = 0;
          this.viewport.scrollTop = 0;
        });

        this.initSwipe();
        this.initZoom();
        this.goToSlide(this.activeIndex, false);
        let rememberedDeal = false;
        try {
          rememberedDeal = Boolean(sessionStorage.getItem('coverax-active-discount'));
        } catch (error) {
          rememberedDeal = false;
        }
        if (this.dealCheckbox && (this.dealCheckbox.checked || rememberedDeal)) {
          this.dealCheckbox.checked = true;
          this.applyDealState(true);
        }
        if (this.dealCheckbox?.checked) this.discoverDealDetails();
        this.initSurfacesCarousel();
        this.boundPlaceUspBar = () => this.placeUspBar();
        this.placeUspBar();
        requestAnimationFrame(this.boundPlaceUspBar);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.boundPlaceUspBar, { once: true });
        }
        this.uspBarMq = window.matchMedia('(max-width: 989px)');
        this.boundPlaceUspBar = () => this.placeUspBar();
        if (this.uspBarMq.addEventListener) {
          this.uspBarMq.addEventListener('change', this.boundPlaceUspBar);
        } else {
          this.uspBarMq.addListener(this.boundPlaceUspBar);
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            const total = event?.cartData?.total_price;
            if (Number.isFinite(total)) this.dataset.cartCents = String(total);
            this.updateShippingHint();
            const applying = Boolean(this.dealCheckbox?.checked);
            if (event?.source === 'coverax-pdp-deal') {
              this.syncDealFromCart(event.cartData, { applying });
              return;
            }
            if (event?.source === 'cart-items') {
              if (event?.cartData) this.syncDealFromCart(event.cartData, { applying });
              return;
            }
            if (event?.source === 'product-form') {
              if (event?.cartData) this.syncDealFromCart(event.cartData, { applying });
              return;
            }
            if (applying && event?.cartData && !this.cartDiscountLive(event.cartData)) {
              this.persistDeal({ silent: true }).catch((error) => console.error(error));
              return;
            }
            if (event?.cartData) this.syncDealFromCart(event.cartData, { applying });
          });
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.cartUpdateUnsubscriber?.();
        if (this.uspBarMq && this.boundPlaceUspBar) {
          if (this.uspBarMq.removeEventListener) {
            this.uspBarMq.removeEventListener('change', this.boundPlaceUspBar);
          } else {
            this.uspBarMq.removeListener(this.boundPlaceUspBar);
          }
        }
        this.restoreUspBar();
        this.closeZoom();
        this.teardownGebindePanel();
      }

      findUspSection() {
        return (
          document.querySelector('#MainContent .shopify-section.section-usp-bar') ||
          document.querySelector('.shopify-section.section-usp-bar') ||
          document.querySelector('#MainContent .shopify-section:has(.usp-bar)')
        );
      }

      placeUspBar() {
        const usp = this.findUspSection();
        const accordions = this.querySelector('.coverax-pdp__accordions');
        const surfaces = this.querySelector('.coverax-pdp__surfaces');
        if (!usp) return;

        if (!this.uspBarHome) {
          this.uspBarHome = document.createComment('coverax-usp-bar-home');
          usp.parentNode.insertBefore(this.uspBarHome, usp);
        }

        if (!window.matchMedia('(max-width: 989px)').matches) {
          this.restoreUspBar();
          return;
        }

        usp.setAttribute('data-pdp-mobile-slot', '');
        if (accordions) {
          accordions.parentNode.insertBefore(usp, accordions);
        } else if (surfaces) {
          surfaces.after(usp);
        }
      }

      restoreUspBar() {
        const usp = this.findUspSection();
        if (!usp) return;
        usp.removeAttribute('data-pdp-mobile-slot');
        if (!this.uspBarHome?.parentNode) return;
        this.uspBarHome.after(usp);
      }

      initSurfacesCarousel() {
        this.surfacesRoot = this.querySelector('[data-pdp-surfaces]');
        this.surfacesScroller = this.querySelector('[data-pdp-surfaces-scroller]');
        if (!this.surfacesRoot || !this.surfacesScroller) return;

        this.surfaceSlides = Array.from(this.surfacesRoot.querySelectorAll('.coverax-pdp__surface'));
        if (!this.surfaceSlides.length) return;

        this.surfacesDots?.remove();
        this.surfacesDots = null;

        let startX = 0;
        let startY = 0;
        let swiped = false;
        this.surfaceSlides.forEach((slide, index) => {
          slide.addEventListener('click', (event) => {
            if (!window.matchMedia('(max-width: 989px)').matches) return;
            if (swiped) {
              swiped = false;
              return;
            }
            event.preventDefault();
            this.goToSurface(index);
          });
        });

        this.surfacesScroller.addEventListener(
          'pointerdown',
          (event) => {
            swiped = false;
            startX = event.clientX;
            startY = event.clientY;
          },
          { passive: true }
        );
        this.surfacesScroller.addEventListener('pointerup', (event) => {
          if (!window.matchMedia('(max-width: 989px)').matches) return;
          const deltaX = event.clientX - startX;
          const deltaY = event.clientY - startY;
          if (Math.abs(deltaX) < 28 || Math.abs(deltaX) < Math.abs(deltaY)) return;
          swiped = true;
          const next = this.currentSurfaceIndex() + (deltaX < 0 ? 1 : -1);
          this.goToSurface((next + this.surfaceSlides.length) % this.surfaceSlides.length);
        });

        this.goToSurface(0);
      }

      goToSurface(index) {
        if (!this.surfaceSlides?.length) return;
        const safeIndex = ((index % this.surfaceSlides.length) + this.surfaceSlides.length) % this.surfaceSlides.length;
        this.surfaceSlides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === safeIndex);
        });
      }

      currentSurfaceIndex() {
        const index = this.surfaceSlides?.findIndex((slide) => slide.classList.contains('is-active'));
        return index >= 0 ? index : 0;
      }

      initGebindePanel() {
        this.gebindeRoot = this.querySelector('[data-pdp-gebinde]');
        if (!this.gebindeRoot) return;
        this.gebindeToggle = this.gebindeRoot.querySelector('[data-pdp-gebinde-toggle]');
        this.gebindePanel = this.gebindeRoot.querySelector('[data-pdp-gebinde-panel]');
        if (!this.gebindeToggle || !this.gebindePanel) return;

        this.boundGebindeToggle = () => this.toggleGebindePanel();
        this.boundGebindeOutside = (event) => {
          if (!this.gebindePanel || this.gebindePanel.hidden) return;
          if (this.gebindeRoot.contains(event.target)) return;
          this.setGebindePanel(false);
        };
        this.boundGebindeKey = (event) => {
          if (event.key !== 'Escape') return;
          if (!this.gebindePanel || this.gebindePanel.hidden) return;
          this.setGebindePanel(false);
          this.gebindeToggle?.focus();
        };

        this.gebindeToggle.addEventListener('click', this.boundGebindeToggle);
        document.addEventListener('pointerdown', this.boundGebindeOutside);
        document.addEventListener('keydown', this.boundGebindeKey);
      }

      teardownGebindePanel() {
        this.gebindeToggle?.removeEventListener('click', this.boundGebindeToggle);
        document.removeEventListener('pointerdown', this.boundGebindeOutside);
        document.removeEventListener('keydown', this.boundGebindeKey);
      }

      toggleGebindePanel() {
        if (!this.gebindePanel) return;
        this.setGebindePanel(this.gebindePanel.hidden);
      }

      setGebindePanel(open) {
        if (!this.gebindePanel || !this.gebindeToggle) return;
        this.gebindePanel.hidden = !open;
        this.gebindeToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      selectCard(card) {
        const variantId = card.dataset.variantId;
        const available = card.dataset.available === 'true';
        const mediaId = card.dataset.mediaId;
        const soldOutLabel = this.dataset.soldOutLabel || '';
        const addLabel = this.dataset.addLabel || '';

        this.cards.forEach((item) => {
          const selected = item === card;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        if (this.variantInput && variantId) {
          this.variantInput.value = variantId;
          this.variantInput.disabled = false;
        }

        this.updateSummaryPrice(card);
        this.updateDealCopy(card);
        this.updateConcentrate(card);

        if (this.stockEl) {
          const inStock = this.stockEl.dataset.inStockText || '';
          const outStock = this.stockEl.dataset.outStockText || '';
          const details = this.stockEl.closest('details.coverax-pdp__stock-details');
          this.stockEl.classList.toggle('is-unavailable', !available);
          if (details) {
            details.classList.toggle('is-unavailable', !available);
            if (!available) details.open = false;
          }
          const extra = this.stockEl.querySelector('[data-pdp-stock-extra]');
          const status = this.stockEl.querySelector('[data-pdp-stock-status]');
          const dash = this.stockEl.querySelector('[data-pdp-stock-dash]');
          const label = this.stockEl.querySelector('[data-pdp-stock-label]');
          if (!available) {
            if (status) status.textContent = outStock;
            else if (label) label.textContent = outStock;
            if (dash) dash.hidden = true;
            if (extra) extra.hidden = true;
          } else if (details) {
            if (status) status.textContent = details.dataset.stockPrefix || status.textContent;
            if (dash) dash.hidden = false;
            if (extra) {
              extra.hidden = false;
              extra.textContent =
                details.classList.contains('is-timer-hidden') || details.classList.contains('is-static')
                  ? details.dataset.stockNext || extra.textContent
                  : details.dataset.stockToday || extra.textContent;
            }
          } else if (label) {
            label.textContent = inStock;
          }
        }

        if (this.submitButton) {
          this.submitButton.disabled = !available;
          this.submitButton.toggleAttribute('aria-disabled', !available);
          if (this.submitLabel) this.submitLabel.textContent = available ? addLabel : soldOutLabel;
        }

        this.updateQuantitySavings(card);

        if (this.quantityInput) {
          const min = card.dataset.min || '1';
          const step = card.dataset.step || '1';
          const max = card.dataset.max || '';
          this.quantityInput.min = min;
          this.quantityInput.dataset.min = min;
          this.quantityInput.step = step;
          if (max) {
            this.quantityInput.max = max;
            this.quantityInput.dataset.max = max;
          } else {
            this.quantityInput.removeAttribute('max');
            delete this.quantityInput.dataset.max;
          }
          if (parseInt(this.quantityInput.value, 10) < parseInt(min, 10)) {
            this.quantityInput.value = min;
          }
          this.updateQuantityOptions();
        }

        this.updateMengeOptions(card);
        this.updatePricePerPiece(card);

        this.closeZoom();
        this.filterSlides(variantId, mediaId);
        this.goToSlide(0);

        if (variantId && this.dataset.updateUrl === 'true') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }
      }

      selectedCard() {
        return this.querySelector('[data-variant-card].is-selected') || this.cards[0];
      }

      selectMengeOption(option) {
        if (!option) return;
        const card = this.cards.find((item) => item.dataset.variantId === option.value);
        if (!card) return;
        option.checked = true;
        this.selectCard(card);
      }

      updateMengeOptions(card) {
        if (!this.mengeOptions.length || !card) return;

        this.mengeOptions.forEach((option) => {
          option.checked = option.value === card.dataset.variantId;
        });

        if (this.mengeCurrentEl) this.mengeCurrentEl.textContent = card.dataset.mengeValue || '';

        const index = this.mengeOptions.findIndex((option) => option.value === card.dataset.variantId);
        if (this.mengeProgress && index >= 0) {
          const total = this.mengeOptions.length;
          const isLast = index >= total - 1;
          const percent = isLast ? 100 : ((index + 0.5) / total) * 100;
          this.mengeProgress.style.width = `${percent}%`;
        }

        this.mengeSavings.forEach((saving) => {
          saving.classList.toggle('is-selected', parseInt(saving.dataset.quantityIndex, 10) === index);
        });
      }

      updatePricePerPiece(card) {
        const el = this.pricePerPieceEl;
        if (!el || !card) return;

        const mengeValue = card.dataset.mengeValue || '';
        const pieces = mengeValue.includes('x')
          ? parseInt(mengeValue.split('x')[0].trim(), 10) || 0
          : parseInt(mengeValue, 10) || 0;
        if (pieces <= 0) return;

        const saleCents = parseInt(card.dataset.saleCents || '', 10);
        const regularCents = parseInt(card.dataset.regularCents || '', 10);
        const cents = this.isDealActive() && Number.isFinite(saleCents) ? saleCents : regularCents;
        if (!Number.isFinite(cents)) return;

        const perPiece = Math.round(cents / pieces);
        const unit = el.dataset.unit || '';
        el.textContent = `nur ${this.formatMoney(perPiece)} pro ${unit}`.trim();
      }

      isDealActive() {
        return Boolean(this.dealCheckbox?.checked);
      }

      updateDealCopy(card) {
        if (!card) return;
        const percent = card.dataset.dealPercent;
        const regular = parseInt(card.dataset.regularCents || '', 10);
        const sale = parseInt(card.dataset.saleCents || '', 10);
        if (percent && this.dealPercent) this.dealPercent.textContent = percent;
        if (this.dealSaving && Number.isFinite(regular) && Number.isFinite(sale)) {
          this.dealSaving.textContent = this.formatMoney(regular - sale);
        }
        if (this.dealSale && Number.isFinite(sale)) this.dealSale.textContent = this.formatMoney(sale);
        if (this.dealRegular && Number.isFinite(regular)) this.dealRegular.textContent = this.formatMoney(regular);
      }

      formatVolumeLabel(ml) {
        const value = Math.round(Number(ml) || 0);
        if (value <= 0) return '';
        if (value >= 1000) {
          const tenths = Math.round((value * 10) / 1000);
          const whole = Math.floor(tenths / 10);
          const frac = tenths % 10;
          return frac === 0 ? `${whole} L` : `${whole},${frac} L`;
        }
        return `${value} ml`;
      }

      updateConcentrate(card) {
        const root = this.querySelector('[data-pdp-concentrate]');
        if (!root) return;

        const packMl = Math.round(
          Number(card?.dataset?.packMl) ||
          Number(root.dataset.packMl) ||
          0
        );
        const ratioA = Number(root.dataset.ratioA) || 0;
        const ratioB = Number(root.dataset.ratioB) || 0;
        if (packMl <= 0 || ratioA <= 0 || ratioB <= 0) return;

        root.dataset.packMl = String(packMl);

        const waterMl = Math.round((packMl * ratioB) / ratioA);
        const packLabel = this.formatVolumeLabel(packMl);
        const waterLabel = this.formatVolumeLabel(waterMl);

        const packEl = root.querySelector('[data-pdp-conc-pack]');
        const waterEl = root.querySelector('[data-pdp-conc-water]');

        if (packEl) packEl.textContent = packLabel;
        if (waterEl) waterEl.textContent = waterLabel;
      }

      updateSummaryPrice(card) {
        const source = card || this.selectedCard() || this.deal;
        if (!source) return;

        const quantityOption = this.quantityOptions.find((option) => option.checked && !option.disabled);
        const quantity = parseInt(quantityOption?.value || this.quantityInput?.value || '1', 10) || 1;
        const discount = parseInt(quantityOption?.dataset.discount || '0', 10) || 0;
        const regularCents = parseInt(source.dataset.regularCents || '', 10);
        const compareAtCents = parseInt(source.dataset.compareCents || '', 10);
        const compareCents =
          Number.isFinite(compareAtCents) && compareAtCents > regularCents ? compareAtCents : regularCents;

        let currentPrice = '';
        let comparePrice = '';
        let showCompare = false;
        let savePercent = 0;
        let offerCents = NaN;

        if (Number.isFinite(regularCents) && Number.isFinite(compareCents)) {
          const compareTotal = compareCents * quantity;
          const currentTotal = Math.round((regularCents * quantity * (100 - discount)) / 100);
          offerCents = currentTotal;
          currentPrice = this.formatMoney(currentTotal);
          comparePrice = this.formatMoney(compareTotal);
          showCompare = currentTotal < compareTotal;
          if (showCompare && compareTotal > 0) {
            savePercent = Math.round(((compareTotal - currentTotal) / compareTotal) * 100);
          }
        }

        if (this.summaryPrice && currentPrice) {
          this.summaryPrice.textContent = currentPrice;
        }
        if (this.summaryComparePrice) {
          this.summaryComparePrice.textContent = comparePrice;
        }
        if (this.summaryCompareWrap) this.summaryCompareWrap.hidden = !showCompare;
        if (this.savePercentEl) {
          this.savePercentEl.textContent = savePercent > 0 ? `-${savePercent} %` : '';
        }

        if (this.unitPrice) {
          const unitPrice = card?.dataset.unitPrice || source.dataset.unitPrice || '';
          this.unitPrice.textContent = unitPrice;
          this.unitPrice.hidden = !unitPrice;
        }

        const active = this.isDealActive();
        this.cards.forEach((item) => {
          const priceEl = item.querySelector('[data-variant-current-price]');
          const compareEl = item.querySelector('[data-variant-compare]');
          const itemRegular = parseInt(item.dataset.regularCents || '', 10);
          const itemSale = parseInt(item.dataset.saleCents || '', 10);
          const itemPrice = this.formatMoney(active && Number.isFinite(itemSale) ? itemSale : itemRegular);
          if (priceEl && itemPrice) priceEl.textContent = itemPrice;
          if (compareEl) {
            compareEl.textContent = Number.isFinite(itemRegular) ? this.formatMoney(itemRegular) : '';
            compareEl.hidden = !active;
          }
        });

        if (Number.isFinite(offerCents)) this.lastOfferCents = offerCents;
        this.updateShippingHint();
        this.updatePlusPoints();
      }

      updatePlusPoints() {
        if (!this.plusPointsEl) return;
        const cents = this.lastOfferCents;
        if (!Number.isFinite(cents) || cents <= 0) return;
        this.plusPointsEl.textContent = String(Math.round((cents * this.plusPointsRate) / 100));
      }

      updateShippingHint() {
        if (!this.shippingEl) return;
        const threshold = parseInt(this.dataset.freeShippingCents || '2500', 10) || 2500;
        const cartCents = parseInt(this.dataset.cartCents || '0', 10) || 0;
        const qualifies = this.lastOfferCents >= threshold || cartCents >= threshold;
        this.shippingEl.classList.toggle('is-free', qualifies);
        if (this.shippingFromEl) this.shippingFromEl.hidden = qualifies;
      }

      formatMoney(cents) {
        const value = Number(cents);
        if (!Number.isFinite(value)) return '';
        const amount = (value / 100).toFixed(2);
        const withComma = amount.replace('.', ',');
        const format = this.dataset.moneyFormat || '{{amount_with_comma_separator}} €';
        return format
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(value / 100)))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(value / 100)))
          .replace(/\{\{\s*amount\s*\}\}/g, amount);
      }

      cartJsUrl(route, fallbackPath) {
        const root = window.Shopify?.routes?.root || '/';
        const path = route || `${root}${fallbackPath}`;
        return path.endsWith('.js') ? path : `${path}.js`;
      }

      async ajaxJson(url, payload) {
        const response = await fetch(url, {
          method: payload ? 'POST' : 'GET',
          credentials: 'same-origin',
          headers: payload
            ? { 'Content-Type': 'application/json', Accept: 'application/json' }
            : { Accept: 'application/json' },
          body: payload ? JSON.stringify(payload) : undefined,
        });
        const text = await response.text();
        try {
          return text ? JSON.parse(text) : null;
        } catch (error) {
          return null;
        }
      }

      dealCacheKey() {
        const code = (this.deal?.dataset.dealCode || '').trim().toLowerCase();
        return code ? `coverax-pdp-deal-v3:${code}` : '';
      }

      readDealCache() {
        try {
          const key = this.dealCacheKey();
          if (!key) return null;
          const data = JSON.parse(sessionStorage.getItem(key) || 'null');
          const percent = Math.round(Number(data?.percent));
          const title = String(data?.title || '').trim();
          if (!title || !Number.isFinite(percent) || percent <= 0) return null;
          return { title, percent };
        } catch (error) {
          return null;
        }
      }

      writeDealCache(title, percent) {
        const key = this.dealCacheKey();
        const clean = String(title || '').trim();
        const value = Math.round(Number(percent));
        if (!key || !clean || !Number.isFinite(value) || value <= 0) return;
        try {
          sessionStorage.setItem(key, JSON.stringify({ title: clean, percent: value }));
        } catch (error) {
          /* Private mode or quota — live cart data still works. */
        }
      }

      normalizeDealPercent(value) {
        const parsed = parseFloat(value);
        if (!Number.isFinite(parsed) || parsed <= 0) return NaN;
        const percent = parsed > 0 && parsed <= 1 ? Math.round(parsed * 100) : Math.round(parsed);
        return percent > 0 ? percent : NaN;
      }

      configuredDealPercent() {
        const value = Math.round(Number(this.deal?.dataset.dealConfiguredPercent || 10));
        return value > 0 ? value : 10;
      }

      dealPercentFromApp(app) {
        if (app && String(app.value_type || '').toLowerCase() === 'percentage') {
          const percent = this.normalizeDealPercent(app.value);
          if (Number.isFinite(percent) && percent > 0) return percent;
        }
        return NaN;
      }

      async discoverDealDetails() {
        if (!this.deal || this._discoveringDeal) return;
        this._discoveringDeal = true;
        const keepDiscount = Boolean(this.dealCheckbox?.checked);
        const root = window.Shopify?.routes?.root || '/';

        try {
          let cart = await this.ajaxJson(`${root}cart.js`);
          this.syncDealFromCart(cart || {}, { applying: keepDiscount });
          let percent = this.extractDealPercent(cart);
          if (Number.isFinite(percent) && percent > 0) {
            this.applyDealPercent(percent);
            this.writeDealCache(this.deal.dataset.dealTitle, percent);
          }

          if (!keepDiscount || !this.dealCodes().length) return;
          if (String(cart?.attributes?.coverax_deal || '') !== '1') {
            await this.stampDealAttribute(true, cart);
          }
        } catch (error) {
          console.error(error);
        } finally {
          this._discoveringDeal = false;
        }
      }

      extractDealPercent(cartData) {
        if (!cartData) return NaN;
        const codes = this.dealCodes().map((code) => code.toLowerCase());
        const picked = this.collectCartDiscountApps(cartData).find((app) => {
          const title = String(app?.title || '').trim().toLowerCase();
          const appCode = String(app?.code || '').trim().toLowerCase();
          return codes.includes(title) || codes.includes(appCode);
        });
        const fromApp = this.dealPercentFromApp(picked);
        if (Number.isFinite(fromApp) && fromApp > 0) return fromApp;

        const productId = String(this.dataset.productId || '');
        const item = (cartData.items || []).find((line) => String(line.product_id) === productId);
        const originalUnit = Number(item?.original_price || 0);
        const quantity = Number(item?.quantity) || 1;
        const originalLine = Number(item?.original_line_price || 0) || originalUnit * quantity;
        if (item) {
          const lineDiscount = (item.discounts || []).reduce((sum, discount) => {
            const title = String(discount?.title || '').trim().toLowerCase();
            if (codes.length && !codes.includes(title)) return sum;
            return sum + Number(discount?.amount || 0);
          }, 0);
          if (originalLine > 0 && lineDiscount > 0) {
            const percent = Math.round((lineDiscount / originalLine) * 100);
            if (percent > 0) return percent;
          }
        }

        const entry = (cartData.discount_codes || []).find((discount) =>
          codes.includes(String(discount?.code || discount || '').trim().toLowerCase())
        );
        const amountCents = Math.round(parseFloat(String(entry?.amount || '0').replace(',', '.')) * 100);
        if (originalLine > 0 && amountCents > 0) {
          const percent = Math.round((amountCents / originalLine) * 100);
          if (percent > 0) return percent;
        }
        return NaN;
      }

      findDealInCart(cartData, { applying = false } = {}) {
        const codes = this.dealCodes().map((code) => code.toLowerCase());
        const apps = this.collectCartDiscountApps(cartData);
        if (!cartData) return null;
        const matched = apps.find((app) => {
          const title = String(app?.title || '').trim().toLowerCase();
          const appCode = String(app?.code || '').trim().toLowerCase();
          return codes.includes(title) || codes.includes(appCode);
        });
        if (matched) return matched;
        return null;
      }

      rememberDealCode(code) {
        const clean = this.sanitizeDealCode(code);
        try {
          if (clean) sessionStorage.setItem('coverax-active-discount', clean);
          else sessionStorage.removeItem('coverax-active-discount');
        } catch (error) {
          /* Private mode — checkout still reads the form field. */
        }
      }

      sanitizeDealCode(code) {
        const clean = String(code || '').trim();
        return /^[A-Za-z0-9ÄÖÜäöüß][A-Za-z0-9ÄÖÜäöüß _-]{0,79}$/.test(clean) ? clean : '';
      }

      cartDiscountLive(cartData) {
        if (!cartData) return false;
        const codes = this.dealCodes().map((code) => code.toLowerCase());
        const percent = this.extractDealPercent(cartData);
        if (Number.isFinite(percent) && percent > 0) return true;
        return (cartData.discount_codes || []).some((entry) => {
          const value = String(entry?.code || '').trim().toLowerCase();
          return codes.includes(value) && entry?.applicable === true;
        });
      }

      dealCodes() {
        const configured = (this.deal?.dataset.dealCode || '').trim();
        const unique = [];
        [configured, 'Sauberer Vorteil', 'Saubesrer Vorteil'].forEach((code) => {
          const clean = String(code || '').trim();
          if (clean && !unique.some((item) => item.toLowerCase() === clean.toLowerCase())) unique.push(clean);
        });
        return unique;
      }

      useDealCode(code) {
        const clean = this.sanitizeDealCode(code);
        if (!clean || !this.deal) return;
        this.deal.dataset.dealCode = clean;
        if (this.dealFormCode) this.dealFormCode.value = this.dealCheckbox?.checked ? clean : '';
        if (this.dealFormAttribute) this.dealFormAttribute.value = this.dealCheckbox?.checked ? '1' : '';
        if (this.dealCheckbox?.checked) this.rememberDealCode(clean);
      }

      async postCartDiscount(code) {
        const root = window.Shopify?.routes?.root || '/';
        const updateUrl = this.cartJsUrl(window.routes?.cart_update_url, 'cart/update');
        const parseCart = async (response) => {
          const text = await response.text();
          try {
            return text ? JSON.parse(text) : null;
          } catch (error) {
            return null;
          }
        };

        let response = await fetch(updateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            discount: code,
            attributes: { coverax_deal: code ? '1' : '' },
          }),
        });
        let cartData = await parseCart(response);

        if (code && !this.cartDiscountLive(cartData)) {
          const params = new URLSearchParams();
          params.set('discount', code);
          params.set('attributes[coverax_deal]', code ? '1' : '');
          response = await fetch(updateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Accept: 'application/json',
            },
            body: params.toString(),
          });
          cartData = await parseCart(response);
        }

        if (cartData?.items) return cartData;
        return (await this.ajaxJson(`${root}cart.js`)) || cartData;
      }

      async applyWorkingCode() {
        let lastCart = null;
        for (const code of this.dealCodes()) {
          lastCart = await this.postCartDiscount(code);
          if (this.cartDiscountLive(lastCart)) {
            this.useDealCode(code);
            return lastCart;
          }
        }
        const fallback = this.dealCodes()[0];
        if (fallback) this.useDealCode(fallback);
        return lastCart;
      }

      collectCartDiscountApps(cartData) {
        const apps = []
          .concat(cartData?.cart_level_discount_applications || [])
          .concat(cartData?.discount_applications || []);
        (cartData?.items || []).forEach((item) => {
          (item.discounts || []).forEach((discount) => apps.push(discount));
        });
        return apps;
      }

      cartHasDeal(cartData) {
        if (this.findDealInCart(cartData)) return true;
        const code = (this.deal?.dataset.dealCode || '').trim().toLowerCase();
        return (cartData?.discount_codes || []).some((entry) => {
          const value = String(entry?.code || entry || '')
            .trim()
            .toLowerCase();
          return value === code;
        });
      }

      applyDealPercent(percent) {
        const value = Math.round(Number(percent));
        if (!Number.isFinite(value) || value <= 0) return;
        if (this.dealPercent) this.dealPercent.textContent = String(value);
        const updateSource = (el) => {
          if (!el) return;
          const regular = parseInt(el.dataset.regularCents || '', 10);
          if (!Number.isFinite(regular)) return;
          const sale = Math.round((regular * (100 - value)) / 100);
          el.dataset.saleCents = String(sale);
          el.dataset.salePrice = this.formatMoney(sale);
          el.dataset.dealPercent = String(value);
        };
        updateSource(this.deal);
        this.cards.forEach((card) => updateSource(card));
      }

      setDealName() {
        const label = (this.deal?.dataset.dealTitle || '').trim() || 'Sauberer Vorteil';
        if (!this.deal) return;
        this.deal.dataset.dealTitle = label;
        if (this.dealRibbonName) this.dealRibbonName.textContent = label;
      }

      syncDealFromCart(cartData, { applying = false } = {}) {
        if (!this.deal || !cartData) return;
        const picked = this.findDealInCart(cartData, { applying });
        const percent = this.extractDealPercent(cartData);
        if (Number.isFinite(percent) && percent > 0) {
          this.setDealName();
          this.applyDealPercent(percent);
          this.writeDealCache(this.deal.dataset.dealTitle, percent);
        }
        if (applying || picked) {
          const card = this.selectedCard();
          if (card) this.updateSummaryPrice(card);
        }
      }

      applyDealState(applyDeal, { animate = false } = {}) {
        this.deal?.classList.toggle('is-active', applyDeal);
        this.deal?.classList.remove('is-activating');
        if (this.dealFormCode) {
          this.dealFormCode.value = applyDeal ? this.deal?.dataset.dealCode || '' : '';
        }
        if (this.dealFormAttribute) this.dealFormAttribute.value = applyDeal ? '1' : '';
        this.rememberDealCode(applyDeal ? this.deal?.dataset.dealCode || this.dealCodes()[0] : '');
        if (typeof window.CoveraxDealPills?.setActive === 'function') {
          window.CoveraxDealPills.setActive(applyDeal);
        } else {
          document.querySelectorAll('cart-drawer').forEach((drawer) => {
            drawer.dataset.coveraxDeal = applyDeal ? '1' : '';
            if (typeof drawer.ensureDealPills === 'function') drawer.ensureDealPills();
          });
        }
        if (animate && applyDeal && this.deal) {
          void this.deal.offsetWidth;
          this.deal.classList.add('is-activating');
        }
        const card = this.selectedCard();
        if (card) this.updateSummaryPrice(card);
        if (animate && applyDeal && this.savePercentEl) {
          this.savePercentEl.classList.remove('is-deal-flash');
          void this.savePercentEl.offsetWidth;
          this.savePercentEl.classList.add('is-deal-flash');
        }
      }

      async stampDealAttribute(active, cartData) {
        const root = window.Shopify?.routes?.root || '/';
        const cart = cartData || (await this.ajaxJson(`${root}cart.js`));
        const attributes = { ...(cart?.attributes || {}) };
        attributes.coverax_deal = active ? '1' : '';
        const updateUrl = this.cartJsUrl(window.routes?.cart_update_url, 'cart/update');
        try {
          const response = await fetch(updateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ attributes }),
          });
          const text = await response.text();
          try {
            return text ? JSON.parse(text) : null;
          } catch (error) {
            return null;
          }
        } catch (error) {
          return null;
        }
      }

      async persistDeal({ silent = false, animate = false } = {}) {
        const applyDeal = Boolean(this.dealCheckbox?.checked);
        if (!this.deal || !this.dealCodes().length) return null;
        if (this.dealPersistInFlight) return this.dealPersistInFlight;

        this.dealPersistInFlight = (async () => {
          const root = window.Shopify?.routes?.root || '/';
          let cartData = await this.ajaxJson(`${root}cart.js`);
          if (applyDeal && this.cartDiscountLive(cartData)) {
            this.syncDealFromCart(cartData, { applying: true });
            this.applyDealState(true, { animate: false });
            if (String(cartData?.attributes?.coverax_deal || '') !== '1') {
              cartData = (await this.stampDealAttribute(true, cartData)) || cartData;
            }
            return cartData;
          }

          cartData = applyDeal ? await this.applyWorkingCode() : await this.postCartDiscount('');
          this.syncDealFromCart(cartData, { applying: applyDeal });
          if (applyDeal) {
            this.applyDealState(true, { animate: false });
            this.rememberDealCode(this.deal?.dataset.dealCode || this.dealCodes()[0]);
          } else {
            this.rememberDealCode('');
            this.applyDealState(false, { animate: false });
          }

          if (!silent) this.applyDealState(applyDeal, { animate: animate && applyDeal });

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'coverax-pdp-deal',
              cartData,
            });
          }

          return cartData;
        })().finally(() => {
          this.dealPersistInFlight = null;
        });

        return this.dealPersistInFlight;
      }

      async releaseDeal() {
        if (this.dealCheckbox?.checked) return null;
        const root = window.Shopify?.routes?.root || '/';
        const cart = await this.ajaxJson(`${root}cart.js`);
        const marked = String(cart?.attributes?.coverax_deal || '') === '1';
        if (!this.cartDiscountLive(cart) && !marked) return cart;
        return this.persistDeal({ silent: true });
      }

      async updateDeal() {
        if (!this.deal || !this.dealCheckbox) return;

        const applyDeal = this.dealCheckbox.checked;
        if (!this.dealCodes().length) {
          this.dealCheckbox.checked = false;
          return;
        }

        this.setDealName();
        this.applyDealState(applyDeal, { animate: applyDeal });
        this.dealCheckbox.disabled = true;
        this.deal.classList.add('is-loading');
        this.deal.setAttribute('aria-busy', 'true');

        try {
          await this.persistDeal({ silent: true });
        } catch (error) {
          console.error(error);
          this.dealCheckbox.checked = !applyDeal;
          this.applyDealState(!applyDeal);
        } finally {
          this.dealCheckbox.disabled = false;
          this.deal.classList.remove('is-loading');
          this.deal.removeAttribute('aria-busy');
        }
      }

      updateQuantitySavings(card) {
        const regular = parseInt((card || this.selectedCard())?.dataset.regularCents || '', 10);
        const prefix = (this.quantitySelector?.dataset.savingPrefix || '').trim();
        this.quantitySavings.forEach((saving) => {
          const index = parseInt(saving.dataset.quantityIndex, 10);
          const option = this.quantityOptions[index];
          if (!option || !Number.isFinite(regular)) return;
          const quantity = parseInt(option.value, 10) || 0;
          const discount = parseInt(option.dataset.discount || '0', 10) || 0;
          const amount = Math.round((regular * quantity * discount) / 100);
          saving.textContent = amount > 0 ? `${prefix} ${this.formatMoney(amount)}`.trim() : '';
        });
      }

      syncQuantityProgress(index) {
        if (!this.quantityProgress || index < 0) return;

        const total = this.quantityOptions.length;
        if (!total) return;

        const isLast = index >= total - 1;
        const percent = isLast ? 100 : ((index + 0.5) / total) * 100;
        this.quantityProgress.style.width = `${percent}%`;
      }

      selectQuantityOption(option, announce = true) {
        if (!option || option.disabled || !this.quantityInput) return;
        const quantity = parseInt(option.value, 10);
        if (!Number.isFinite(quantity)) return;

        option.checked = true;
        this.quantityInput.value = String(quantity);
        if (this.quantityCurrent) this.quantityCurrent.textContent = String(quantity);

        const index = this.quantityOptions.indexOf(option);
        this.syncQuantityProgress(index);
        this.quantitySavings.forEach((saving) => {
          saving.classList.toggle('is-selected', parseInt(saving.dataset.quantityIndex, 10) === index);
        });

        this.updateSummaryPrice(this.selectedCard());

        if (announce) {
          this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      updateQuantityOptions() {
        if (!this.quantityOptions.length || !this.quantityInput) return;
        const min = parseInt(this.quantityInput.min || this.quantityInput.dataset.min || '1', 10);
        const max = parseInt(this.quantityInput.max || this.quantityInput.dataset.max || '', 10);
        const step = parseInt(this.quantityInput.step || '1', 10);

        this.quantityOptions.forEach((option) => {
          const quantity = parseInt(option.value, 10);
          const belowMinimum = quantity < min;
          const aboveMaximum = Number.isFinite(max) && quantity > max;
          const missesStep = step > 1 && (quantity - min) % step !== 0;
          option.disabled = belowMinimum || aboveMaximum || missesStep;
        });

        const selected = this.quantityOptions.find((option) => option.checked && !option.disabled);
        const fallback = this.quantityOptions.find((option) => !option.disabled);
        if (selected || fallback) {
          this.selectQuantityOption(selected || fallback, false);
        } else {
          this.quantityInput.value = String(min);
          if (this.quantityCurrent) this.quantityCurrent.textContent = String(min);
          if (this.quantityProgress) this.quantityProgress.style.width = '0%';
        }
      }

      slideMatchesVariant(slide, variantId) {
        const ids = slide.dataset.variantIds || '';
        if (!ids) return true;
        if (!variantId) return false;
        return ids.includes(`,${variantId},`);
      }

      filterSlides(variantId, featuredMediaId = '') {
        this.allSlides.forEach((slide) => {
          slide.hidden = !this.slideMatchesVariant(slide, variantId);
        });

        const visibleSlides = this.allSlides.filter((slide) => !slide.hidden);
        const featuredSlide = visibleSlides.find((slide) => slide.dataset.mediaId === featuredMediaId);
        this.slides = featuredSlide
          ? [featuredSlide, ...visibleSlides.filter((slide) => slide !== featuredSlide)]
          : visibleSlides;

        if (this.track) {
          this.slides.forEach((slide) => this.track.append(slide));
          this.allSlides.filter((slide) => slide.hidden).forEach((slide) => this.track.append(slide));
        }

        this.gallery?.classList.toggle('is-single', this.slides.length < 2);
        if (this.pager) this.pager.hidden = this.slides.length < 2;
        this.syncThumbs();
        this.layoutSlides();
      }

      slideStep() {
        if (!this.viewport || !this.slides.length) return 0;
        return this.viewport.clientWidth;
      }

      layoutSlides() {
        if (!this.viewport || !this.slides.length) return;
        const slideWidth = this.viewport.clientWidth;
        this.slides.forEach((slide, index) => {
          slide.style.width = `${slideWidth}px`;
          slide.style.left = `${index * slideWidth}px`;
        });
      }

      getSlideOffset(index) {
        if (!this.slides.length) return 0;
        const step = this.slideStep();
        const maxOffset = Math.max(0, (this.slides.length - 1) * step);
        return Math.min(Math.max(index, 0) * step, maxOffset);
      }

      updatePager() {
        const total = this.slides.length;
        const current = this.activeIndex + 1;

        if (this.counterEl && total > 0) {
          this.counterEl.textContent = this.counterTemplate
            .replace(/\{\{\s*current\s*\}\}/g, String(current))
            .replace(/\{\{\s*total\s*\}\}/g, String(total))
            .replace(/\d+\s*\/\s*\d+/, `${current}/${total}`);
        }

        if (this.progressThumb && total > 0) {
          this.progressThumb.style.width = `${100 / total}%`;
          this.progressThumb.style.transform = `translateX(${this.activeIndex * 100}%)`;
        }

        this.toggleNavButton(this.prevBtn, total < 2 || this.activeIndex === 0);
        this.toggleNavButton(this.nextBtn, total < 2 || this.activeIndex === total - 1);
        this.updateThumbActive();
        this.syncZoomNav();
      }

      syncThumbs() {
        if (!this.thumbs.length) return;
        this.thumbs.forEach((thumb) => {
          const visible = this.slides.some((slide) => slide.dataset.mediaId === thumb.dataset.mediaId);
          thumb.hidden = !visible;
        });
        if (this.thumbsWrap) {
          this.slides.forEach((slide) => {
            const thumb = this.thumbs.find((item) => item.dataset.mediaId === slide.dataset.mediaId);
            if (thumb) this.thumbsWrap.append(thumb);
          });
          this.thumbsWrap.hidden = this.slides.length < 2;
          this.thumbsWrap.scrollTop = 0;
        }
        this.updateThumbActive();
      }

      updateThumbActive() {
        if (!this.thumbs.length) return;
        const activeId = this.slides[this.activeIndex]?.dataset.mediaId || '';
        this.thumbs.forEach((thumb) => {
          const active = thumb.dataset.mediaId === activeId;
          thumb.classList.toggle('is-active', active);
          if (active) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }

      toggleNavButton(button, hide) {
        if (!button) return;
        if (hide && document.activeElement === button) button.blur();
        button.hidden = hide;
        button.tabIndex = hide ? -1 : 0;
        button.setAttribute('aria-hidden', hide ? 'true' : 'false');
      }

      goToSlide(index, animate = true) {
        if (!this.slides.length) return;
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;
        const total = this.slides.length;
        this.activeIndex = Math.min(Math.max(index, 0), total - 1);
        this.layoutSlides();

        this.allSlides.forEach((slide) => {
          slide.classList.toggle('is-active', slide === this.slides[this.activeIndex]);
        });

        if (this.track) {
          this.track.style.transition = animate ? 'transform 320ms ease' : 'none';
          this.track.style.transform = `translateX(-${this.getSlideOffset(this.activeIndex)}px)`;
        }

        if (this.viewport) {
          this.viewport.scrollLeft = 0;
          this.viewport.scrollTop = 0;
        }

        this.updatePager();
        if (document.activeElement === this.prevBtn || document.activeElement === this.nextBtn) {
          document.activeElement.blur();
        }
        window.scrollTo(scrollX, scrollY);
      }

      initSwipe() {
        if (!this.track || !this.viewport) return;
        let startX = 0;
        let startY = 0;
        let deltaX = 0;
        let dragging = false;
        let axis = '';

        const point = (event) => (event.touches ? event.touches[0] : event);

        const onStart = (event) => {
          if (this.slides.length < 2) return;
          const current = point(event);
          dragging = true;
          axis = '';
          startX = current.clientX;
          startY = current.clientY;
          deltaX = 0;
          this.track.style.transition = 'none';
        };

        const onMove = (event) => {
          if (!dragging) return;
          const current = point(event);
          const moveX = current.clientX - startX;
          const moveY = current.clientY - startY;
          if (!axis && (Math.abs(moveX) > 8 || Math.abs(moveY) > 8)) {
            axis = Math.abs(moveX) >= Math.abs(moveY) ? 'x' : 'y';
            if (axis === 'x') this.viewport.classList.add('is-dragging');
          }
          if (axis !== 'x') return;
          if (event.cancelable) event.preventDefault();
          deltaX = moveX;
          this.track.style.transform = `translateX(${-this.getSlideOffset(this.activeIndex) + deltaX}px)`;
        };

        const onEnd = () => {
          if (!dragging) return;
          const swiped = axis === 'x';
          dragging = false;
          axis = '';
          this.viewport.classList.remove('is-dragging');
          if (!swiped) {
            deltaX = 0;
            return;
          }
          const threshold = this.viewport.clientWidth * 0.18;
          if (deltaX > threshold) {
            this.goToSlide(this.activeIndex - 1);
          } else if (deltaX < -threshold) {
            this.goToSlide(this.activeIndex + 1);
          } else {
            this.goToSlide(this.activeIndex);
          }
          deltaX = 0;
        };

        this.viewport.addEventListener('touchstart', onStart, { passive: true });
        this.viewport.addEventListener('touchmove', onMove, { passive: false });
        this.viewport.addEventListener('touchend', onEnd);
        this.viewport.addEventListener('touchcancel', onEnd);
        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          onStart(event);
        });
        this.viewport.addEventListener('pointermove', (event) => {
          if (event.pointerType !== 'mouse') return;
          onMove(event);
        });
        this.viewport.addEventListener('pointerup', (event) => {
          if (event.pointerType !== 'mouse') return;
          onEnd();
        });
        this.viewport.addEventListener('pointercancel', onEnd);
        this.viewport.addEventListener('pointerleave', () => {
          if (dragging) onEnd();
        });
      }

      initZoom() {
        this.zoomDialog = this.querySelector('[data-pdp-zoom]');
        this.zoomFrame = this.querySelector('[data-pdp-zoom-frame]');
        this.zoomImage = this.querySelector('[data-pdp-zoom-image]');
        this.zoomOpenBtn = this.querySelector('[data-pdp-zoom-open]');
        this.zoomCloseBtn = this.querySelector('[data-pdp-zoom-close]');
        this.zoomInBtn = this.querySelector('[data-pdp-zoom-in]');
        this.zoomOutBtn = this.querySelector('[data-pdp-zoom-out]');
        this.zoomPrevBtn = this.querySelector('[data-pdp-zoom-prev]');
        this.zoomNextBtn = this.querySelector('[data-pdp-zoom-next]');
        this.zoomScale = 1;
        this.zoomX = 0;
        this.zoomY = 0;
        this.minZoom = 1;
        this.maxZoom = 4;
        if (!this.zoomDialog || !this.zoomImage || !this.zoomFrame) return;

        this.zoomOpenBtn?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.openZoom();
        });

        this.zoomCloseBtn?.addEventListener('click', () => this.closeZoom());
        this.zoomDialog.addEventListener('close', () => this.resetZoomTransform());
        this.zoomDialog.addEventListener('click', (event) => {
          if (event.target === this.zoomDialog) this.closeZoom();
        });
        this.zoomDialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.stepZoomSlide(1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.stepZoomSlide(-1);
          }
        });

        this.zoomInBtn?.addEventListener('click', () => this.setZoomScale(this.zoomScale + 0.5));
        this.zoomOutBtn?.addEventListener('click', () => this.setZoomScale(this.zoomScale - 0.5));
        this.zoomPrevBtn?.addEventListener('click', () => this.stepZoomSlide(-1));
        this.zoomNextBtn?.addEventListener('click', () => this.stepZoomSlide(1));

        this.zoomFrame.addEventListener('click', (event) => {
          if (event.target !== this.zoomFrame || this.zoomScale > 1) return;
          this.closeZoom();
        });

        this.zoomFrame.addEventListener(
          'wheel',
          (event) => {
            event.preventDefault();
            const delta = event.deltaY > 0 ? -0.25 : 0.25;
            this.setZoomScale(this.zoomScale + delta, event.clientX, event.clientY);
          },
          { passive: false }
        );

        this.zoomImage.addEventListener('click', (event) => {
          if (this.zoomDidPan) {
            this.zoomDidPan = false;
            return;
          }
          if (this.zoomScale > 1) this.setZoomScale(1);
          else this.setZoomScale(2.5, event.clientX, event.clientY);
        });

        this.initZoomGestures();
        this.syncZoomNav();
      }

      initZoomGestures() {
        let pointerId = null;
        let startX = 0;
        let startY = 0;
        let originX = 0;
        let originY = 0;
        let pinchStart = 0;
        let pinchScale = 1;

        const point = (touch) => ({ x: touch.clientX, y: touch.clientY });
        const distance = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);

        this.zoomFrame.addEventListener(
          'pointerdown',
          (event) => {
            if (event.pointerType !== 'mouse' || event.button !== 0 || this.zoomScale <= 1) return;
            pointerId = event.pointerId;
            this.zoomDidPan = false;
            startX = event.clientX;
            startY = event.clientY;
            originX = this.zoomX;
            originY = this.zoomY;
            this.zoomFrame.setPointerCapture(event.pointerId);
            this.zoomDialog.classList.add('is-panning');
          }
        );

        this.zoomFrame.addEventListener('pointermove', (event) => {
          if (pointerId !== event.pointerId) return;
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          if (Math.abs(dx) > 3 || Math.abs(dy) > 3) this.zoomDidPan = true;
          this.zoomX = originX + dx;
          this.zoomY = originY + dy;
          this.clampZoomPan();
          this.applyZoomTransform();
        });

        const endPan = (event) => {
          if (pointerId !== event.pointerId) return;
          pointerId = null;
          this.zoomDialog.classList.remove('is-panning');
        };

        this.zoomFrame.addEventListener('pointerup', endPan);
        this.zoomFrame.addEventListener('pointercancel', endPan);

        this.zoomFrame.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length === 2) {
              pinchStart = distance(point(event.touches[0]), point(event.touches[1]));
              pinchScale = this.zoomScale;
              this.zoomDidPan = true;
              return;
            }
            if (event.touches.length === 1 && this.zoomScale > 1) {
              const touch = event.touches[0];
              pointerId = 'touch';
              this.zoomDidPan = false;
              startX = touch.clientX;
              startY = touch.clientY;
              originX = this.zoomX;
              originY = this.zoomY;
              this.zoomDialog.classList.add('is-panning');
            }
          },
          { passive: true }
        );

        this.zoomFrame.addEventListener(
          'touchmove',
          (event) => {
            if (event.touches.length === 2 && pinchStart) {
              if (event.cancelable) event.preventDefault();
              const midX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
              const midY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
              const next = pinchScale * (distance(point(event.touches[0]), point(event.touches[1])) / pinchStart);
              this.setZoomScale(next, midX, midY);
              return;
            }
            if (pointerId !== 'touch' || event.touches.length !== 1) return;
            if (event.cancelable) event.preventDefault();
            const touch = event.touches[0];
            const dx = touch.clientX - startX;
            const dy = touch.clientY - startY;
            if (Math.abs(dx) > 3 || Math.abs(dy) > 3) this.zoomDidPan = true;
            this.zoomX = originX + dx;
            this.zoomY = originY + dy;
            this.clampZoomPan();
            this.applyZoomTransform();
          },
          { passive: false }
        );

        this.zoomFrame.addEventListener('touchend', (event) => {
          if (event.touches.length < 2) pinchStart = 0;
          if (event.touches.length === 0) {
            pointerId = null;
            this.zoomDialog.classList.remove('is-panning');
          }
        });
      }

      openZoom() {
        const slide = this.slides?.[this.activeIndex];
        if (!this.zoomDialog || !slide) return;
        this.resetZoomTransform();
        this.setZoomImage(slide);
        this.syncZoomNav();
        if (typeof this.zoomDialog.showModal === 'function') this.zoomDialog.showModal();
        else this.zoomDialog.setAttribute('open', '');
      }

      closeZoom() {
        if (!this.zoomDialog) return;
        if (this.zoomDialog.open) this.zoomDialog.close();
        else this.zoomDialog.removeAttribute('open');
        this.resetZoomTransform();
      }

      stepZoomSlide(step) {
        if (!this.slides?.length) return;
        this.goToSlide(this.activeIndex + step);
        this.resetZoomTransform();
        this.setZoomImage(this.slides[this.activeIndex]);
        this.syncZoomNav();
      }

      setZoomImage(slide) {
        if (!this.zoomImage || !slide) return;
        const img = slide.querySelector('img');
        const source = img?.currentSrc || img?.src || '';
        const zoomSrc = source.replace(/([?&])width=\d+/i, `$1width=1800`) || source;
        this.zoomImage.alt = img?.alt || '';
        this.zoomImage.sizes = '100vw';
        this.zoomImage.srcset = zoomSrc ? `${zoomSrc} 1800w` : '';
        this.zoomImage.src = zoomSrc || source;
        if (img?.naturalWidth && img?.naturalHeight) {
          this.zoomImage.width = img.naturalWidth;
          this.zoomImage.height = img.naturalHeight;
        }
      }

      syncZoomNav() {
        if (!this.zoomDialog) return;
        const total = this.slides?.length || 0;
        this.toggleNavButton(this.zoomPrevBtn, total < 2 || this.activeIndex === 0);
        this.toggleNavButton(this.zoomNextBtn, total < 2 || this.activeIndex >= total - 1);
        this.updateZoomControls();
      }

      updateZoomControls() {
        if (this.zoomOutBtn) this.zoomOutBtn.disabled = this.zoomScale <= this.minZoom;
        if (this.zoomInBtn) this.zoomInBtn.disabled = this.zoomScale >= this.maxZoom;
        this.zoomDialog?.classList.toggle('is-zoomed', this.zoomScale > 1);
      }

      setZoomScale(next, clientX, clientY) {
        const previous = this.zoomScale;
        const scale = Math.min(this.maxZoom, Math.max(this.minZoom, next));
        if (scale === previous) {
          this.updateZoomControls();
          return;
        }
        if (clientX != null && this.zoomFrame) {
          const rect = this.zoomFrame.getBoundingClientRect();
          const cx = clientX - rect.left - rect.width / 2;
          const cy = clientY - rect.top - rect.height / 2;
          const ratio = scale / previous;
          this.zoomX = cx - (cx - this.zoomX) * ratio;
          this.zoomY = cy - (cy - this.zoomY) * ratio;
        }
        this.zoomScale = scale;
        if (scale <= 1) {
          this.zoomX = 0;
          this.zoomY = 0;
        }
        this.clampZoomPan();
        this.applyZoomTransform();
        this.updateZoomControls();
      }

      clampZoomPan() {
        if (this.zoomScale <= 1 || !this.zoomFrame || !this.zoomImage) {
          if (this.zoomScale <= 1) {
            this.zoomX = 0;
            this.zoomY = 0;
          }
          return;
        }
        const frameWidth = this.zoomFrame.clientWidth;
        const frameHeight = this.zoomFrame.clientHeight;
        const imageWidth = this.zoomImage.offsetWidth * this.zoomScale;
        const imageHeight = this.zoomImage.offsetHeight * this.zoomScale;
        const maxX = Math.max(0, (imageWidth - frameWidth) / 2);
        const maxY = Math.max(0, (imageHeight - frameHeight) / 2);
        this.zoomX = Math.min(maxX, Math.max(-maxX, this.zoomX));
        this.zoomY = Math.min(maxY, Math.max(-maxY, this.zoomY));
      }

      applyZoomTransform() {
        if (!this.zoomImage) return;
        this.zoomImage.style.transform = `translate(${this.zoomX}px, ${this.zoomY}px) scale(${this.zoomScale})`;
      }

      resetZoomTransform() {
        this.zoomScale = 1;
        this.zoomX = 0;
        this.zoomY = 0;
        this.zoomDidPan = false;
        this.applyZoomTransform();
        this.updateZoomControls();
      }
    }
  );
}
